export const isAuthenticated = state => state.isAuthenticated;
export const user = state => state.user;
export const loading = state => state.loading;


// WEBPACK FOOTER //
// ./src/store/getters.js